<template>
  <rest-page :fetch-endpoint="fetchEndpoint">
    <page-header :title="pageTitle" />

    <page-content>
      <notification-error :model="model" />

      <notification-details :model="model" />

      <notification-recipients
        v-if="$can('UserData::ReadAccess')"
        :model="model"
      />

      <notification-deliveries :model="model" v-if="interactionsAvailable" />

      <notification-interactions :model="model" v-if="interactionsAvailable" />
    </page-content>
  </rest-page>
</template>

<script>
import RestPage from '@/common/components/rest/RestPage'
import PageHeader from '@/common/components/page/PageHeader'
import PageContent from '@/common/components/page/PageContent'
import NotificationDetails from '@/modules/notifications-log/components/NotificationDetails'
import NotificationInteractions from '@/modules/notifications-log/components/NotificationInteractions'
import NotificationDeliveries from '@/modules/notifications-log/components/NotificationDeliveries'
import NotificationRecipients from '@/modules/notifications-log/components/NotificationRecipients'
import NotificationError from '@/modules/notifications-log/components/NotificationError'
import { projectEndpoint } from '@/core/helpers'
import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'

export default {
  name: 'NotificationLogListPage',

  components: {
    NotificationDeliveries,
    NotificationDetails,
    NotificationRecipients,
    NotificationInteractions,
    NotificationError,
    RestPage,
    PageHeader,
    PageContent
  },
  data() {
    return {
      model: {
        application: {},
        message_type: null
      }
    }
  },

  computed: {
    pageTitle() {
      return (
        this.$store.getters.embeddedTitle || this.$t(this.$route.meta.title)
      )
    },

    fetchEndpoint() {
      if (this.$route.query.id) {
        return projectEndpoint({
          method: 'get',
          url: `actions/${this.$route.query.id}`,
          params: {
            expand: 'application_name,message,campaign,mxa_multi_langauge'
          },
          handler: data => {
            Object.assign(this.model, data)
          }
        })
      } else {
        return null
      }
    },

    interactionsAvailable() {
      return this.model.message_type !== MessageTypeEnum.PROMOTION
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/notifications-log/pages/NotificationDetailsPage.vue